import { render, staticRenderFns } from "./history.vue?vue&type=template&id=caa12f0e&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caa12f0e')) {
      api.createRecord('caa12f0e', component.options)
    } else {
      api.reload('caa12f0e', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=caa12f0e&", function () {
      api.rerender('caa12f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/historyComponent/history.vue"
export default component.exports